var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", disabled: !_vm.tooltipText },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function({ on }) {
              return [
                _c(
                  "v-btn",
                  _vm._g(
                    _vm._b(
                      {
                        staticClass: "d-flex justify-start",
                        class: _vm.specificClass,
                        attrs: {
                          small: "",
                          text: _vm.isText,
                          outlined: _vm.outlined,
                          tile: ""
                        },
                        on: { click: _vm.handleClick }
                      },
                      "v-btn",
                      _vm.$attrs,
                      false
                    ),
                    on
                  ),
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v(_vm._s(_vm.icon))
                    ]),
                    _vm._v(" "),
                    _vm.hasSlot
                      ? _vm._t("default")
                      : _c("truncate-text-with-hover", {
                          attrs: { text: _vm.btnText, length: 20 }
                        })
                  ],
                  2
                )
              ]
            }
          }
        ],
        null,
        true
      )
    },
    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltipText))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }